module.exports = __webpack_public_path__ + "static/media/internal-projects.9f5e7e20.jpg";